<script setup lang="ts">
</script>
<template>
  <a class="text-sm lg:text-base font-normal text-[var(--p-primary-color)] no-underline hover:underline">
    <slot />
  </a>
</template>
